export default __webpack_public_path__ + "images/0x2c89bbc92bd86f8075d1decc58c7f4e0107f286b.png";